module.exports = __webpack_public_path__ + "static/media/AB_L31_11.6cdc06c2.jpg";